import { render, staticRenderFns } from "./logisticsListAction.vue?vue&type=template&id=4620ab4a&scoped=true"
import script from "./logisticsListAction.vue?vue&type=script&lang=js"
export * from "./logisticsListAction.vue?vue&type=script&lang=js"
import style0 from "./logisticsListAction.vue?vue&type=style&index=0&id=4620ab4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4620ab4a",
  null
  
)

export default component.exports